import Modal from "@mui/material/Modal";
import { useState } from "react";
import Loader from "../../components/Loader";
import toast from "react-hot-toast";
import { getFetchFile } from "../../api/employeeDetails";

// Helper function to format date into DD-MM-YYYY
const formatDateToDDMMYYYY = (dateString) => {
  const dateObj = new Date(dateString);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = dateObj.getFullYear();
  return `${day}-${month}-${year}`;
};

const UploadAttendanceFile = ({ open, handleClose, onSuccess }) => {
  const [report, setReportState] = useState({
    date: "",
    file: null,
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChangeReportState = (e) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setReportState((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    } else {
      setReportState((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleUploadFile = async (e) => {
    e.preventDefault();

    if (!report.file) {
      toast.error("Please select a file");
      return;
    }

    const formattedDate = formatDateToDDMMYYYY(report.date);

    const payload = {
      date: formattedDate,
      fetch_from_ftp: "false",
      upload_file: "true",
      file: report.file,
    };

    try {
      setIsLoading(true);
      const response = await getFetchFile(payload);
      toast.success("File Uploaded successfully!");

      // Refresh data using callback
      if (onSuccess) onSuccess();
      console.log("API Response: ", response);
    } catch (error) {
      toast.error("There was an error uploading the file");
      console.error("API Error: ", error);
    } finally {
      setIsLoading(false);
      handleClose();
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className=" bg-white w-[40%] rounded-md absolute left-1/2 -translate-x-1/2 top-6">
        <div>
          <h1 className=" font-semibold text-xl px-4 py-3">
            Upload Attendance File
          </h1>
          <form className="px-4 py-4 space-y-4" onSubmit={handleUploadFile}>
            <div className="grid grid-cols-2 gap-4">
              <div className="">
                <label htmlFor="date" className="label">
                  Date:<span className="mandatory">*</span>
                </label>
                <input
                  id="date"
                  type="date"
                  required
                  name="date"
                  className="input"
                  onChange={handleChangeReportState}
                  value={report.date}
                />
              </div>
              <div className="">
                <label htmlFor="file" className="label">
                  File (CSV only):<span className="mandatory">*</span>
                </label>
                <input
                  id="file"
                  type="file"
                  required
                  name="file"
                  accept=".csv"
                  className="input"
                  onChange={handleChangeReportState}
                />
              </div>
            </div>
            <div className=" space-x-4 text-center">
              <button
                disabled={isLoading}
                type="submit"
                className=" bg-blue-200 text-blue-700 font-semibold px-4 py-2 rounded"
              >
                <div className=" flex items-center justify-center space-x-3">
                  <span>Upload</span>
                  {isLoading && <Loader className={"text-blue-700"} />}
                </div>
              </button>
              <button
                type="button"
                onClick={handleClose}
                className=" border font-semibold px-4 py-2 rounded"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default UploadAttendanceFile;
